import ax from "axios";

const networkTimeoutMs = 20_000;

const axios = ax.create({
  timeout: networkTimeoutMs,
  headers: {
    Accept: "application/json",
  },
});

export default axios;
